import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a12e11b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a12e11b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12e11b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a12e11b')) {
      api.createRecord('6a12e11b', component.options)
    } else {
      api.reload('6a12e11b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a12e11b&scoped=true", function () {
      api.rerender('6a12e11b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemberInfo/index.vue"
export default component.exports